import { Button, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	onClick?: () => void;
	children: ReactNode;
};

export const WhiteCtaButton: FC<Props> = ({ onClick, children }) => {
	const theme = useTheme();
	const white = theme.palette.darkmodeText.white;

	return (
		<Button
			onClick={onClick}
			sx={{
				px: 3,
				py: 1.2,
				gap: 0.6,
				color: theme.palette.blue[600],
				backgroundColor: white,
				borderRadius: theme.radii.xl,
				fontSize: 14,
				fontWeight: 600,
				lineHeight: 1.45,
				textTransform: "none",
				boxShadow: theme.shadow.blueGlow,
				"&:hover": { backgroundColor: white },
				"&:active": { transform: "scale(0.97)" },
			}}
		>
			{children}
		</Button>
	);
};
